import * as React from 'react';
import { Label } from '@fluentui/react/lib/Label';
import { Select } from 'formComponents/Select/Select';
import { ValueType } from 'react-select';
import { SelectOption } from 'formComponents/Select/types';
import { MenuPlacement } from 'react-select/src/types';
import { useSelector } from 'react-redux';
import { lieferantenformulareSelector, lieferantenformulareByNrSelector } from 'store/lookups/selector';

interface LieferantenformularProps {
    label: string;
    disabled: boolean;
    value: number;
    menuPlacement?: MenuPlacement;
    allowEmpty?: boolean;
    onChange: (newValue: number) => void;
}

export const Lieferantenformular: React.FC<LieferantenformularProps> = ({
    label,
    value,
    disabled,
    menuPlacement = 'bottom',
    allowEmpty = false,
    onChange,
}) => {
    const lieferantenformulare = useSelector(lieferantenformulareSelector);
    const lieferantenformulareByNr = useSelector(lieferantenformulareByNrSelector);

    const options = React.useMemo(() => {
        const o = lieferantenformulare
            .sort((a, b) => b.nr - a.nr)
            .map((a) => ({
                value: a.nr.toString(),
                label: a.anzName,
            }));

        if (allowEmpty) {
            o.push({ value: '', label: '' });
        }

        return o;
    }, [lieferantenformulare, allowEmpty]);

    return (
        <>
            <Label>{label}</Label>
            <Select
                name={label}
                isDisabled={disabled}
                isClearable={allowEmpty}
                value={
                    value !== undefined && value !== null
                        ? {
                              value: value.toString(),
                              label: lieferantenformulareByNr[value]?.anzName || value.toString(),
                          }
                        : {
                              value: '',
                              label: '',
                          }
                }
                options={options}
                menuPlacement={menuPlacement}
                onChange={(option: ValueType<SelectOption, false>): void => {
                    onChange(parseInt(option?.value || '0', 10));
                }}
            />
        </>
    );
};
